import { createScenarioStub } from "../scenarioFlow/ScenarioFlowStub";
import { ROUTES } from "../../utils/constants";

export default createScenarioStub({
	scenarioNum: 4,
	kind: "context",
	label: "Contexto 6 (plantilla)",
	nextRoute: ROUTES.SCENARIO4_FIN,
});
